module.exports = __webpack_public_path__ + "static/media/illustration-attendee-list-web.cf10cbf6.png";